import {MinimumValue} from "../MinimumValue";
import {sprintf} from 'sprintf-js';
import {ValidatorInterface} from "../ValidatorInterface";
import {IModel} from "makerjs";
import AbstractValidatorSet from "./AbstractValidatorSet";
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import Length from "../../../../../source/js/shared/models/Geometry/Length";
import { DrillholeNoEffectValidator } from "../DrillholeNoEffectValidator";
import EdgeDrillHoles from "@/Models/EdgeDrillHoles";
import GridDrillHoles from "@/Models/GridDrillHoles";
import RadialDrillHoles from "@/Models/RadialDrillHoles";
import PresetDrillHoles from "@/Models/PresetDrillHoles";

export default class RadialDrillHoleValidatorSet extends AbstractValidatorSet {
	private readonly minHoleDiameter: Length;
	private readonly state;
	private readonly shape: string;
	private readonly parsedDimensions: object;
	private readonly drillHoles: IModel;
	private readonly parentModel: IModel;
	private readonly drillHoleInstance: any;

	constructor( minHoleDiameter: Length, state, shape: string, parsedDimensions: object, drillHoles: IModel, parentModel: IModel, drillHoleInstance: EdgeDrillHoles | GridDrillHoles | RadialDrillHoles | PresetDrillHoles | null) {
		super();

		this.minHoleDiameter = minHoleDiameter;
		this.state = state;
		this.shape = shape;
		this.parsedDimensions = parsedDimensions;
		this.drillHoles = drillHoles;
		this.parentModel = parentModel;
		this.drillHoleInstance = drillHoleInstance;
	}

	getValidators(): ValidatorInterface[] {
		const { drillHole } = this.getValidatorTranslationStrings();

		return [
			new MinimumValue( {
				field: 'drillHoleDiameter',
				dimension: 'drillHoleDiameter',
				value: this.state.drillHoleDiameter,
				minimum: this.minHoleDiameter.in_mm(),
				customMessage: sprintf( drillHole.diameter.min, this.minHoleDiameter.in_cm_i18n() )
			} ),
			new MinimumValue( {
				field: 'drillHoleRadialAmount',
				dimension: 'drillHoleRadialAmount',
				value: this.state.drillHoleRadialAmount,
				minimum: 3,
				customMessage: sprintf( drillHole.amount.min, 3 )
			} ),
			new MinimumValue( {
				field: 'drillHoleRadialDiameter',
				dimension: 'drillHoleRadialDiameter',
				value: this.state.drillHoleRadialDiameter,
				minimum: 3,
				customMessage: sprintf( drillHole.radial.diameter, 3 )
			} ),
			new MaximumDecimalPoints( {
				field: 'drillHoleDiameter',
				dimension: 'drillHoleDiameter',
				value: new Length( this.state.drillHoleDiameter ).in_cm(),
				customMessage: sprintf( drillHole.diameter.decimals, 1 )
			} ),
			new MaximumDecimalPoints( {
				field: 'drillHoleRadialDiameter',
				dimension: 'drillHoleRadialDiameter',
				value: new Length( this.state.drillHoleRadialDiameter ).in_cm(),
				customMessage: sprintf( drillHole.radial.decimals.diameter, 1 )
			} ),
			new MaximumDecimalPoints( {
				field: 'drillHoleRadialOffsetX',
				dimension: 'drillHoleRadialOffsetX',
				value: new Length( this.state.drillHoleRadialOffsetX ).in_cm(),
				customMessage: sprintf( drillHole.radial.decimals.offsetX, 1 )
			} ),
			new MaximumDecimalPoints( {
				field: 'drillHoleRadialOffsetY',
				dimension: 'drillHoleRadialOffsetY',
				value: new Length( this.state.drillHoleRadialOffsetY ).in_cm(),
				customMessage: sprintf( drillHole.radial.decimals.offsetY, 1 )
			} ),
			new DrillholeNoEffectValidator(
				this.parentModel,
				this.drillHoleInstance,
				{
					field: 'drillHolesMissing',
					dimension: 'drillHolesMissing',
				}
			),
		];
	}
}
